export default {
  en: {
    flightschool: {
      management: {
        tabs: {
          settings: 'Settings',
          address: 'Address',
          members: 'Members',
        },
        member: {
          invite: 'Invite Member',
          kick: 'Kick Member',
          kicked: 'Member kicked successfully.',
          created_at: 'Invited at',
          joined_at: 'Joined at',
          is_owner: 'Is owner',
          is_student: 'Is student',
          is_flightinstructor: 'Is flightinstructor',
          is_admin: 'Is admin',
          save: 'Save Changes',
          saved: 'Member updated successfully.',
        },
        name: 'Flight School Name',
        slug: 'Unique Identifier',
        description: 'Description',
        website: 'Website',
        phone: 'Phone Number',
        email: 'Contact Email',
        address_line1: 'Address Line 1',
        address_line2: 'Address Line 2',
        city: 'City',
        state: 'State/Province',
        postal_code: 'Postal Code',
        country: 'Country',
        save: 'Save Changes',
        updatesuccess: 'Flight School details updated successfully.',
        is_club: 'Is this a club?',
        is_publicly_visible: 'Is this flight school publicly visible?',
        is_members_visible: 'Are members visible to non-members?',
        home_airport: 'Home Airport ICAO',
      },
      invite_member:{
        title: 'Invite Member to Flight School',
        explain: 'Enter the email address of the person you want to invite to your flight school. They will receive an email with instructions on how to join.',
        send: 'Send Invite',
        emailinvalid: 'The email address is invalid',
        invited: 'Invitation sent successfully to {email}',
      }
    }
  },
  de: {
    flightschool: {
      management: {
        tabs: {
          settings: 'Einstellungen',
          address: 'Adresse',
          members: 'Mitglieder',
        },
        member: {
          invite: 'Mitglied einladen',
          kick: 'Mitglied entfernen',
          kicked: 'Mitglied erfolgreich entfernt.',
          created_at: 'Eingeladen am',
          joined_at: 'Beigetreten am',
          is_owner: 'Ist Inhaber',
          is_student: 'Ist Flugschüler',
          is_flightinstructor: 'Ist Fluglehrer',
          is_admin: 'Ist Admin',
          save: 'Änderungen speichern',
          saved: 'Mitglied erfolgreich aktualisiert.',
        },
        name: 'Name der Flugschule',
        slug: 'Eindeutiger Bezeichner',
        description: 'Beschreibung',
        website: 'Webseite',
        phone: 'Telefonnummer',
        email: 'Kontakt E-Mail',
        address_line1: 'Adresszeile 1',
        address_line2: 'Adresszeile 2',
        city: 'Stadt',
        state: 'Bundesland/Provinz',
        postal_code: 'Postleitzahl',
        country: 'Land',
        save: 'Änderungen speichern',
        updatesuccess: 'Flugschuldetails erfolgreich aktualisiert.',
        is_club: 'Ist dies ein Verein?',
        is_publicly_visible: 'Ist diese Flugschule öffentlich sichtbar?',
        is_members_visible: 'Sind Mitglieder für Nicht-Mitglieder sichtbar?',
        home_airport: 'Heimatflughafen ICAO',
      },
      invite_member:{
        title: 'Mitglied zur Flugschule einladen',
        explain: 'Geben Sie die E-Mail-Adresse der Person ein, die Sie zu Ihrer Flugschule einladen möchten. Sie erhalten eine E-Mail mit Anweisungen, wie sie beitreten können.',
        send: 'Einladung senden',
        emailinvalid: 'Die E-Mail-Adresse ist ungültig',
        invited: 'Einladung erfolgreich an {email} gesendet',
      }
    }
  }
}
